import { PlanDetailsId } from "../../@types/ids";

export const featuredSubtitleClassNames =
  "ds-u-md-margin-top--1 ds-u-font-size--sm ds-u-font-weight--normal";
export const mgovFooterClassName = "m-c-footer";
export const planDetailsPlanInfoId = PlanDetailsId.PlanInfo;
export const mGovRedesignBlockClass = "mgov-redesign-block";
